/* infinite-scroll.js — VERSION 7 */
(function () {
  'use strict';

  const VERSION = 7;
  const TAG = '[infinite-scroll v' + VERSION + ']';
  const GRID_SELECTOR = '#product-grid';
  const ITEM_SELECTOR = '.grid__item';
  const PAGINATION_SELECTOR = '.pagination-wrapper';
  const TRIGGER_DISTANCE_PX = 2000;

  console.log(TAG, 'loaded');

  function init() {
    const gridContainer = document.querySelector(GRID_SELECTOR);
    const pagination = document.querySelector(PAGINATION_SELECTOR);
    if (!gridContainer || !pagination) {
      console.log(TAG, 'no grid or pagination, exiting');
      return;
    }
    // On collection pages, #product-grid IS the <ul>. On search pages,
    // #product-grid is a <div> with a <ul class="product-grid"> inside.
    // Always append to the actual <ul> so <li>s don't end up orphaned.
    const grid =
      gridContainer.matches('ul')
        ? gridContainer
        : gridContainer.querySelector('ul.product-grid, ul.grid');
    if (!grid) {
      console.log(TAG, 'could not locate <ul> inside #product-grid, exiting');
      return;
    }

    const firstNextUrl = findNextUrl(pagination);
    if (!firstNextUrl) {
      console.log(TAG, 'no next link, single-page collection');
      return;
    }

    const state = {
      grid,
      pagination,
      appending: false,
      done: false,
      pending: prefetchBatch(firstNextUrl),
      nextUrl: firstNextUrl,
    };

    pagination.style.display = 'none';

    const sentinel = document.createElement('div');
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    // base.css hides `div:empty`, which would leave the observer blind (and the
    // scroll fallback firing on every event), so the sentinel carries an
    // invisible text node.
    sentinel.appendChild(document.createTextNode(' '));
    sentinel.style.cssText =
      'width:100%;height:1px;margin:0;padding:0;overflow:hidden;font-size:0;line-height:0;';
    pagination.parentNode.insertBefore(sentinel, pagination);

    const status = document.createElement('div');
    status.className = 'infinite-scroll-status';
    status.style.cssText =
      'text-align:center;padding:1.5rem 1rem;font-size:0.95rem;opacity:0.7;';
    status.textContent = 'Loading more products…';
    pagination.parentNode.insertBefore(status, pagination);

    state.sentinel = sentinel;
    state.status = status;

    // Trigger 1: IntersectionObserver
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const e of entries) {
            if (e.isIntersecting) {
              console.log(TAG, 'observer fired');
              tryAppend(state);
            }
          }
        },
        { rootMargin: TRIGGER_DISTANCE_PX + 'px 0px' }
      );
      observer.observe(sentinel);
      state.observer = observer;
    }

    // Trigger 2: scroll/resize listener (fallback)
    const onScroll = () => {
      if (state.done || state.appending) return;
      const rect = state.sentinel.getBoundingClientRect();
      // An all-zero rect means the sentinel is not rendered: nothing to do.
      if (!rect.width && !rect.height) return;
      if (rect.top < window.innerHeight + TRIGGER_DISTANCE_PX) {
        tryAppend(state);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    state.onScroll = onScroll;

    // Trigger 3: initial check after layout settles, in case sentinel is
    // already within the trigger zone on page load
    requestAnimationFrame(() => {
      setTimeout(onScroll, 50);
    });

    // Trigger 4: manual click on the status text as ultimate fallback
    status.style.cursor = 'pointer';
    status.addEventListener('click', () => tryAppend(state));

    console.log(TAG, 'ready, prefetching', firstNextUrl);
  }

  function findNextUrl(paginationWrapper, baseUrl) {
    const ref = baseUrl ? new URL(baseUrl) : window.location;
    let currentPage = parseInt(paginationWrapper.dataset.page, 10);
    if (!currentPage) {
      const fromUrl = parseInt(new URL(ref.href || ref).searchParams.get('page'), 10);
      currentPage = fromUrl || 1;
    }
    const nextPage = currentPage + 1;
    const links = paginationWrapper.querySelectorAll('a[href]');
    for (const a of links) {
      const url = new URL(a.getAttribute('href'), window.location.origin);
      const p = parseInt(url.searchParams.get('page'), 10);
      if (p === nextPage) return url.toString();
    }
    return null;
  }

  function prefetchBatch(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((res) => {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector(GRID_SELECTOR);
        const items = newGrid ? Array.from(newGrid.querySelectorAll(ITEM_SELECTOR)) : [];
        const frag = document.createDocumentFragment();
        items.forEach((node) => frag.appendChild(document.adoptNode(node)));
        const newPagination = doc.querySelector(PAGINATION_SELECTOR);
        const nextUrl = newPagination ? findNextUrl(newPagination, url) : null;
        return { items: frag, nextUrl, count: items.length, sourceUrl: url };
      })
      .catch((err) => {
        console.error(TAG, 'fetch failed for', url, err);
        return { items: null, nextUrl: null, count: 0, sourceUrl: url, error: err };
      });
  }

  async function tryAppend(state) {
    if (state.appending || state.done || !state.pending) return;
    state.appending = true;
    state.status.textContent = 'Loading more products…';

    let batch;
    try {
      batch = await state.pending;
    } catch (err) {
      console.error(TAG, 'unexpected', err);
      state.appending = false;
      return;
    }
    state.pending = null;

    if (!batch || !batch.items || batch.count === 0) {
      state.status.innerHTML =
        'Couldn’t load more — <a href="' +
        (batch && batch.sourceUrl ? batch.sourceUrl : '#') +
        '">click to retry</a>';
      // Allow retry by re-arming
      state.pending = prefetchBatch(state.nextUrl);
      state.appending = false;
      return;
    }

    state.grid.appendChild(batch.items);
    console.log(TAG, 'appended', batch.count, 'items');

    window.dispatchEvent(
      new CustomEvent('infinite-scroll:loaded', {
        detail: { url: batch.sourceUrl, nextUrl: batch.nextUrl, count: batch.count },
      })
    );

    if (batch.nextUrl) {
      state.nextUrl = batch.nextUrl;
      state.pending = prefetchBatch(batch.nextUrl);
      state.appending = false;
      // Re-check immediately in case more is needed (fast scroll)
      requestAnimationFrame(() => state.onScroll && state.onScroll());
    } else {
      state.done = true;
      state.status.textContent = 'You’ve reached the end.';
      state.status.style.cursor = 'default';
      if (state.observer) state.observer.disconnect();
      window.removeEventListener('scroll', state.onScroll);
      window.removeEventListener('resize', state.onScroll);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
